export default __webpack_public_path__ + "static/media/screen6.40e6df39.png";